import { useIntl } from 'react-intl';

import { CreditCardGradient, MailGradient, PencilScribbleGradient } from '@calm-web/icons';

import messages from './messages';
import { IconWrapper, Section, SectionDescription, SectionTitle, Title, Wrapper } from './styles';

const HowItWorks = () => {
	const { formatMessage } = useIntl();

	return (
		<Wrapper columns={3}>
			<Title>{formatMessage(messages.title)}</Title>
			<Section>
				<IconWrapper>
					<PencilScribbleGradient />
				</IconWrapper>
				<SectionTitle>{formatMessage(messages.personalizeStepTitle)}</SectionTitle>
				<SectionDescription>{formatMessage(messages.personalizeStepDescription)}</SectionDescription>
			</Section>
			<Section>
				<IconWrapper>
					<CreditCardGradient />
				</IconWrapper>
				<SectionTitle>{formatMessage(messages.purchaseStepTitle)}</SectionTitle>
				<SectionDescription>{formatMessage(messages.purchaseStepDescription)}</SectionDescription>
			</Section>
			<Section>
				<IconWrapper>
					<MailGradient />
				</IconWrapper>
				<SectionTitle>{formatMessage(messages.sendStepTitle)}</SectionTitle>
				<SectionDescription>{formatMessage(messages.sendStepDescription)}</SectionDescription>
			</Section>
		</Wrapper>
	);
};

export default HowItWorks;
